module.exports = __webpack_public_path__ + "img/fog.4a9fa61d.png";